// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_SHOW_MORE_DISCUSSIONS = "Zobraz \u010fal\u0161ie diskusie";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskusie";
